"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NestedFlipTiles = _interopRequireDefault(require("./NestedFlipTiles.scss"));

var _RemoteControlService = require("../../../KESI2/Services/RemoteControlService");

var _KESI2BasicComponent = _interopRequireDefault(require("../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../KESI2/KesiConstants");

var _KESI2Helper = _interopRequireWildcard(require("../../../KESI2/KESI2Helper"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _LogService = _interopRequireDefault(require("../../../KESI2/Services/LogService"));

var _NavigationManagerCordova = _interopRequireDefault(require("../../NavigationManagerCordova"));

var _ArrayHelper = require("../../../helpers/ArrayHelper");

var _ScreenHelper = _interopRequireDefault(require("../../../helpers/ScreenHelper"));

var _StringHelper = _interopRequireDefault(require("../../../helpers/StringHelper"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _DrupalTiles = require("./DrupalTiles");

var _FlippingTiles = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/FlippingTiles.js"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _TilesAnimationHelper = _interopRequireWildcard(require("./TilesAnimationHelper"));

var _DrupalNestedTileSizes = require("./DrupalNestedTileSizes");

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _UrlHelper = _interopRequireDefault(require("../../../helpers/UrlHelper"));

var _AppUtils = require("../../../utils/AppUtils");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var NEEDED_WIDTH_XLARGE_SCREEN = 5 * _DrupalNestedTileSizes.TILE_SIZES.LARGE + 10 * _DrupalNestedTileSizes.MARGIN_BETWEEN_TILES;
var NEEDED_WIDTH_LARGE_SCREEN = 4 * _DrupalNestedTileSizes.TILE_SIZES.LARGE + 8 * _DrupalNestedTileSizes.MARGIN_BETWEEN_TILES;
var NEEDED_WIDTH_MEDIUM_SCREEN = 3 * _DrupalNestedTileSizes.TILE_SIZES.LARGE + 6 * _DrupalNestedTileSizes.MARGIN_BETWEEN_TILES;
var NEEDED_WIDTH_SMALL_SCREEN = 2 * _DrupalNestedTileSizes.TILE_SIZES.LARGE + 4 * _DrupalNestedTileSizes.MARGIN_BETWEEN_TILES;
var NEEDED_WIDTH_RESET_SCREEN = _DrupalNestedTileSizes.TILE_SIZES.LARGE + 2 * _DrupalNestedTileSizes.MARGIN_BETWEEN_TILES;
var LEVELS = {
  ROOT: 'root',
  COURSE: 'course',
  SPOC: 'spoc',
  LECTURE: 'lecture'
};

var DrupalNestedFlippingTiles = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalNestedFlippingTiles, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalNestedFlippingTiles);

  function DrupalNestedFlippingTiles(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalNestedFlippingTiles);
    _this = _super.call(this, props, context, props.currentId);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onTilesComponentDidUpdateCallback", function () {
      if (_this.onTilesComponentDidUpdate) {
        var func = _this.onTilesComponentDidUpdate;
        _this.onTilesComponentDidUpdate = null;
        func();
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onWindowSizeChanged", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var zoomAndColumnCount;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              zoomAndColumnCount = _this.calculateZoomValue();

              _this.setState({
                zoomValue: zoomAndColumnCount.zoom,
                colCount: zoomAndColumnCount.colCount
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "goUp", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var usedJump, nextCompletePath, nextId, content, colorToUse, currentUrl, baseUrlPart, baseUrl;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this.state.navigationAllowed) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", _promise["default"].reject(new Error('navigation not allowed')));

            case 2:
              usedJump = _NavigationManagerCordova["default"].getUsedJump();

              if (!usedJump) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return", _NavigationManagerCordova["default"].jumpBack());

            case 5:
              nextCompletePath = (0, _ArrayHelper.getArrayWithoutLastElement)(_this.props.contentPathArray);

              if (!(nextCompletePath.length > 0)) {
                _context2.next = 29;
                break;
              }

              nextId = (0, _ArrayHelper.getLastElement)(nextCompletePath);
              content = _KESI2Helper["default"].getContentById(nextId);

              if (!(_config["default"].useTileBackgroundColorInTile && (content.type === LEVELS.ROOT || !content.type))) {
                _context2.next = 14;
                break;
              }

              if ((_config["default"].useTileBackgroundColorInTile || _config["default"].openTilesInFullScreen) && (content.type === LEVELS.ROOT || !content.type)) {
                _NavigationManagerCordova["default"].setNavbarBackgroundColor(null);
              } else if (_config["default"].useTileBackgroundColorInTile && (content.type === LEVELS.SPOC || _config["default"].usesCourses && content.type === LEVELS.COURSE)) {
                colorToUse = content.innerColor ? content.innerColor : content.backgroundColor;

                _NavigationManagerCordova["default"].setNavbarBackgroundColor(colorToUse);
              }

              _context2.next = 13;
              return (0, _TimeoutHelper.timeout)();

            case 13:
              return _context2.abrupt("return", _NavigationManagerCordova["default"].goTo("".concat(_config["default"].baseRoute, "/").concat(nextCompletePath.join(_KesiConstants.KESI_PATH_DELIMITER))));

            case 14:
              currentUrl = window.location.href;

              if (!currentUrl) {
                _context2.next = 28;
                break;
              }

              baseUrlPart = currentUrl.split('#');

              if (!(baseUrlPart.length > 1)) {
                _context2.next = 28;
                break;
              }

              baseUrl = baseUrlPart[baseUrlPart.length - 1].split('!');

              if (!(baseUrl.length > 1)) {
                _context2.next = 28;
                break;
              }

              baseUrl.pop();
              _context2.next = 23;
              return (0, _TimeoutHelper.timeout)();

            case 23:
              if (!(baseUrl[0].indexOf(_config["default"].baseRoute) !== -1)) {
                _context2.next = 27;
                break;
              }

              return _context2.abrupt("return", _NavigationManagerCordova["default"].goTo("".concat(baseUrl.join(_KesiConstants.KESI_PATH_DELIMITER))));

            case 27:
              return _context2.abrupt("return", _NavigationManagerCordova["default"].goTo("".concat(_config["default"].baseRoute, "/").concat(baseUrl.join(_KesiConstants.KESI_PATH_DELIMITER))));

            case 28:
              return _context2.abrupt("return", _promise["default"].reject(new Error('Cannot go up')));

            case 29:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onOpenTile", function () {// TODO: Not working anymore, scrolling is now in DrupalTiles
      // const backgroundFrameId = this.getFrameElementId(true)
      // const foregroundFrameId = this.getFrameElementId(false)
      //
      // const backgroundFrameEl = document.getElementById(backgroundFrameId)
      // const foregroundFrameEl = document.getElementById(foregroundFrameId)
      //
      // if (backgroundFrameEl && foregroundFrameEl) {
      //   backgroundFrameEl.scrollTop = foregroundFrameEl.scrollTop
      //   this.setState({scrollTop: foregroundFrameEl.scrollTop})
      // }
    });
    _this.outerPageId = _StringHelper["default"].createShortId();
    _this.state = _objectSpread({
      contentPathArray: null,
      idOfContentWithBackside: null,
      // the id of the content that will have a back side
      lastPath: [],
      flipped: false,
      rootFlipped: false,
      animated: true,
      initialized: false,
      navigationAllowed: true,
      zoomValue: -1,
      colCount: -1,
      showGoUpButtonOnBack: false,
      scrollTop: 0,
      closingTransitionForTile: null,
      // only when closing to root
      showBackground: false,
      showBackgroundTiles: false,
      hideTileForIdInBackground: null,
      doNotRenderFlipping: false,
      willBeRoot: false
    }, _this.state);
    _this.onTilesComponentDidUpdate = null;
    _this.prevDocumentOverflow = '';
    setTimeout(function () {
      // noinspection JSIgnoredPromiseFromCall  -->  don't wait for this promise to complete
      _this.initForEntityWithPath(props.contentPathArray);

      _this.setState({
        initialized: true
      });
    });
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalNestedFlippingTiles.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE, _DataStore.DATA_STORE_PATHS.IS_ZOOMED]);
    return _this;
  }

  (0, _createClass2["default"])(DrupalNestedFlippingTiles, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var zoomAndColumnCount, currentUrl, baseUrlPart, baseUrl, root, rootLength, currentPath, pathParts, _root, _rootLength;

        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _ScreenHelper["default"].instance().addOnWindowSizeChangedListener(this.onWindowSizeChanged);

                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  window.screen.orientation.addEventListener('change', this.onWindowSizeChanged);
                }

                this.props.setShowFavButton(true);
                _context3.next = 5;
                return (0, _TimeoutHelper.timeout)();

              case 5:
                zoomAndColumnCount = this.calculateZoomValue();
                this.setState({
                  // eslint-disable-line react/no-did-mount-set-state  -->  because the warning is wrong
                  zoomValue: zoomAndColumnCount.zoom,
                  colCount: zoomAndColumnCount.colCount
                });
                console.log('NestedFlippingTiles currentPath', _NavigationManagerCordova["default"].getCurrentPath());

                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context3.next = 22;
                  break;
                }

                currentUrl = window.location.href;

                if (!currentUrl) {
                  _context3.next = 20;
                  break;
                }

                baseUrlPart = currentUrl.split('#');

                if (!(baseUrlPart.length > 1)) {
                  _context3.next = 20;
                  break;
                }

                baseUrl = baseUrlPart[baseUrlPart.length - 1].split('!');
                console.log('baseUrl', baseUrl);

                if (!(_config["default"].showOnlyLectures && baseUrl.length === 2)) {
                  _context3.next = 17;
                  break;
                }

                return _context3.abrupt("return");

              case 17:
                root = _config["default"].cordovaStartUrl().split(_KesiConstants.KESI_PATH_DELIMITER);
                rootLength = root.length;

                if (baseUrl.length > rootLength) {
                  this.props.setBackButtonFunc(this.goUp);
                }

              case 20:
                _context3.next = 27;
                break;

              case 22:
                currentPath = _NavigationManagerCordova["default"].getCurrentPath();
                pathParts = currentPath.split('!');
                _root = _config["default"].cordovaStartUrl().split(_KesiConstants.KESI_PATH_DELIMITER);
                _rootLength = _root.length;

                if (pathParts.length > _rootLength) {
                  this.props.setBackButtonFunc(this.goUp);
                }

              case 27:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(prevProps, prevState, snapshot) {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalNestedFlippingTiles.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);

                if ((0, _ArrayHelper.shallowEqual)(prevProps.contentPathArray, this.props.contentPathArray)) {
                  _context4.next = 4;
                  break;
                }

                _context4.next = 4;
                return this.initForEntityWithPath(this.props.contentPathArray, prevProps);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function componentDidUpdate(_x, _x2, _x3) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
    /*
    async componentWillReceiveProps (nextProps) {
      // compare by stringify is okay because the paths only contains strings
      if (!shallowEqual(this.props.contentPathArray, nextProps.contentPathArray)) {
        await this.initForEntityWithPath(nextProps.contentPathArray)
      }
    }
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalNestedFlippingTiles.prototype), "componentWillUnmount", this).call(this);

      _ScreenHelper["default"].instance().removeOnWindowSizeChangedListener(this.onWindowSizeChanged);

      if (!_DeviceInfoHelper["default"].isBrowser()) {
        window.screen.orientation.removeEventListener('change', this.onWindowSizeChanged);
      }
    }
  }, {
    key: "getScrollElementId",

    /** @namespace window.device */
    value: function getScrollElementId(forBackground) {
      return "scroll-frame-".concat(forBackground ? 'background' : 'not-background', "-").concat((0, _ArrayHelper.getLastElement)(this.state.contentPathArray));
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      var hideTileTransitions = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_HIDE_TILE_ANIMATION) || false;
      var style = {
        backgroundTiles: {
          opacity: 1,
          overflowX: 'hidden'
        },
        backgroundTilesHidden: {
          opacity: 0,
          overflowX: 'hidden'
        },
        tileFrameRoot: {
          transform: 'translate3d(0, 0, 0) scale(1)',
          transformOrigin: 'center',
          transition: hideTileTransitions ? 'none' : 'transform 500ms',
          height: _config["default"].showBottomBar && !_config["default"].showBottomBarOnlyInLecturesAndSpocs ? "calc(100vh - ".concat(_cssConstants["default"].navBarHeight, "px - ").concat(_cssConstants["default"].bottomBarHeight, "px)") : "calc(100vh - ".concat(_cssConstants["default"].navBarHeight, "px)"),
          overflow: 'hidden auto',
          backgroundColor: _cssConstants["default"].colors.backgroundColor ? _cssConstants["default"].colors.backgroundColor : 'white'
        },
        tileFrame: {
          transform: "translate3d(0, 0, 0) scale(".concat(_config["default"].scaleOverlayTiles, ")"),
          transformOrigin: 'center',
          transition: hideTileTransitions ? 'none' : 'transform 500ms, background-color 200ms',
          overflow: 'hidden auto',
          // WebkitOverflowScrolling: 'touch',
          height: _config["default"].showBottomBar && !_config["default"].showBottomBarOnlyInLecturesAndSpocs ? "calc(100vh - ".concat(_cssConstants["default"].navBarHeight, "px - ").concat(_cssConstants["default"].bottomBarHeight, "px)") : "calc(100vh - ".concat(_cssConstants["default"].navBarHeight, "px)"),
          width: '100%',
          // position: 'fixed',
          backgroundColor: _cssConstants["default"].colors.backgroundColor ? _cssConstants["default"].colors.backgroundColor : 'white'
        },
        tileFrameHidden: {
          opacity: 0,
          backgroundColor: 'transparent'
        }
      };
      style.tileFrameRootFlipped = (0, _assign["default"])({}, style.tileFrame);
      style.tileFrameRootFlipped.overflow = 'hidden';

      if (this.state.zoomValue < 0) {
        // hide everything until an appropriate zoom value is found
        style.tileFrame.opacity = 0;
        style.tileFrameRoot.opacity = 0;
        style.backgroundTiles.opacity = 0;
      }

      return style;
    }
  }, {
    key: "initForEntityWithPath",
    value: function () {
      var _initForEntityWithPath = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(nextPathArray) {
        var prevProps,
            nextId,
            path,
            basePath,
            checkId,
            i,
            id,
            prevPathArray,
            _args6 = arguments;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                prevProps = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : null;

                if (this.state.navigationAllowed) {
                  _context6.next = 5;
                  break;
                }

                _context6.next = 4;
                return (0, _TimeoutHelper.timeout)(200);

              case 4:
                return _context6.abrupt("return", this.initForEntityWithPath(nextPathArray, prevProps));

              case 5:
                nextId = (0, _ArrayHelper.getLastElement)(nextPathArray);
                path = _NavigationManagerCordova["default"].getCurrentPath();
                basePath = _UrlHelper["default"].getBasePath();
                console.log('initForEntityWithPath path', basePath);

                checkId = function checkId(id, path) {
                  console.log('initForEntityWithPath checking id', id);

                  if (id) {
                    var isVisible = _KESI2Helper["default"].checkIfContentVisible(id);

                    var loggedIn = _config["default"].isLoggedIn();

                    if (isVisible) {
                      var isAccessible = _KESI2Helper["default"].checkIfContentAccessible(id);
                    } else {
                      if (!loggedIn) {
                        var checkCampaignIdAndGoToPath = /*#__PURE__*/function () {
                          var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(messageId) {
                            return _regenerator["default"].wrap(function _callee5$(_context5) {
                              while (1) {
                                switch (_context5.prev = _context5.next) {
                                  case 0:
                                    if (!messageId) {
                                      _context5.next = 3;
                                      break;
                                    }

                                    _context5.next = 3;
                                    return (0, _AppUtils.getAppInstance)().retrieveAndHandleConfigMessages(messageId);

                                  case 3:
                                    console.log('checking message id done');

                                    _NavigationManagerCordova["default"].goTo(basePath);

                                  case 5:
                                  case "end":
                                    return _context5.stop();
                                }
                              }
                            }, _callee5);
                          }));

                          return function checkCampaignIdAndGoToPath(_x5) {
                            return _ref3.apply(this, arguments);
                          };
                        }();

                        var urlParams = _UrlHelper["default"].getUrlParams();

                        var messageId = urlParams ? urlParams['campaignId'] : null;
                        console.log('initForEntityWithPath not logged in, go to path after login', basePath, messageId);
                        if (messageId && _config["default"].openLogin) _config["default"].openLogin(function () {
                          return checkCampaignIdAndGoToPath(messageId);
                        });
                      }

                      return _NavigationManagerCordova["default"].goHome(false);
                    }
                  }
                };

                checkId(nextId, path);

                if (nextPathArray.length > 2) {
                  for (i = nextPathArray.length - 2; i > 0; i--) {
                    id = nextPathArray[i];
                    console.log('check if id is maybe locked behind a precondition', id);
                    checkId(id, path);
                  }
                } // const nextPathJoined = nextPathArray.join('!')


                (0, _LogService["default"])(nextId, path);

                if ((0, _KESI2Helper.isRemoteControllingEnabled)()) {
                  (0, _RemoteControlService.pushNavigateMessage)(nextId, path);
                }

                prevPathArray = prevProps ? prevProps.contentPathArray : this.props.contentPathArray;
                this.prepareUpcomingAnimation(nextPathArray, prevPathArray);
                this.setState({
                  lastPath: prevPathArray
                });
                return _context6.abrupt("return", _promise["default"].resolve());

              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function initForEntityWithPath(_x4) {
        return _initForEntityWithPath.apply(this, arguments);
      }

      return initForEntityWithPath;
    }()
  }, {
    key: "calculateZoomValue",
    value: function calculateZoomValue() {
      var zoom = -1; // eslint-disable-line no-magic-numbers

      var colCount = -1; // eslint-disable-line no-magic-numbers

      var outerPage = document.getElementById(this.outerPageId);

      if (outerPage) {
        var appMaxWidth = _cssConstants["default"].appMaxWidth ? _cssConstants["default"].appMaxWidth : 1024;
        var availWidth = outerPage.offsetWidth > appMaxWidth ? appMaxWidth : outerPage.offsetWidth;
        var divisor;

        if (availWidth >= NEEDED_WIDTH_XLARGE_SCREEN) {
          divisor = NEEDED_WIDTH_XLARGE_SCREEN;
          colCount = 5;
        } else if (availWidth >= NEEDED_WIDTH_LARGE_SCREEN) {
          divisor = NEEDED_WIDTH_LARGE_SCREEN;
          colCount = 4;
        } else if (availWidth >= NEEDED_WIDTH_MEDIUM_SCREEN * 0.8) {
          divisor = NEEDED_WIDTH_MEDIUM_SCREEN;
          colCount = 3;
        } else if (availWidth >= NEEDED_WIDTH_SMALL_SCREEN * 0.65) {
          divisor = NEEDED_WIDTH_SMALL_SCREEN;
          colCount = 2;
        } else {
          divisor = NEEDED_WIDTH_RESET_SCREEN;
          colCount = 1;
        } // Drupal css adds it to scrollFrame, which is the child of the element we get here -> so do not subtract 20px here
        // if (DeviceInfoHelper.isBrowser()) {
        //   // css from server usually adds 20 pixel to circumvent problems with scroll bars
        //   // but this causes problems if there are scroll bars
        //   availWidth -= 20
        // }


        zoom = availWidth / divisor;
      }

      return {
        zoom: zoom,
        colCount: colCount
      };
    }
  }, {
    key: "getDeviceSpecificGoingDownWaitingTime",
    value: function getDeviceSpecificGoingDownWaitingTime() {
      if (!_DeviceInfoHelper["default"].isBrowser() && window.device.platform === 'Android') {
        return 1000;
      }

      if (_DeviceInfoHelper["default"].isBrowser()) {
        return 200;
      }

      return 800;
    }
  }, {
    key: "getDeviceSpecificGoingUpWaitingTime",
    value: function getDeviceSpecificGoingUpWaitingTime() {
      if (!_DeviceInfoHelper["default"].isBrowser() && window.device.platform === 'Android') {
        return 500;
      }

      return 0;
    }
  }, {
    key: "prepareUpcomingAnimation",
    value: function () {
      var _prepareUpcomingAnimation = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(nextPathArray, prevPathArray) {
        var expectedCommonStepsIfAny, isPathWithSameAncestors, goingDown, goingUp, initial, sibling, onlySameRoot, hideTileTransitions, currentContent, currentPath, pathParts, rootLength, _currentContent, idOfContentWithBackside, pathArrayWithOutLastElement, _currentContent2, _pathArrayWithOutLastElement, _idOfContentWithBackside, nextContent, _idOfContentWithBackside2, state, _nextContent, newState, _idOfContentWithBackside3, parentCourse, rootIdParts, rootId, willBeRoot, nextState;

        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                console.log('prepareUpcomingAnimation1');
                expectedCommonStepsIfAny = Math.min(nextPathArray.length, prevPathArray.length);
                isPathWithSameAncestors = (0, _ArrayHelper.shallowEqual)(nextPathArray, prevPathArray, expectedCommonStepsIfAny);
                goingDown = isPathWithSameAncestors && nextPathArray.length === prevPathArray.length + 1;
                goingUp = isPathWithSameAncestors && nextPathArray.length + 1 === prevPathArray.length;
                initial = !this.state.initialized;
                sibling = this.state.initialized && !goingDown && !goingUp && nextPathArray.length === prevPathArray.length && (0, _ArrayHelper.shallowEqual)(nextPathArray, prevPathArray, nextPathArray.length - 1);
                onlySameRoot = this.state.initialized && !goingDown && !goingUp && !sibling;
                console.log('prepareUpcomingAnimation2');
                hideTileTransitions = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_HIDE_TILE_ANIMATION) || false;
                console.log('prepareUpcomingAnimation3', hideTileTransitions);

                if (!initial) {
                  _context7.next = 18;
                  break;
                }

                currentContent = _KESI2Helper["default"].getContentByPath(nextPathArray);
                this.setState({
                  // currentContent,
                  contentPathArray: nextPathArray,
                  flipped: false,
                  navigationAllowed: true,
                  initialized: true,
                  doNotRenderFlipping: false
                });

                if (!_config["default"].showOnlyLectures) {
                  this.props.setShowFavButton(null);
                  currentPath = _NavigationManagerCordova["default"].getCurrentPath();
                  pathParts = currentPath.split('!');
                  rootLength = _config["default"].cordovaStartUrl().split(_KesiConstants.KESI_PATH_DELIMITER);

                  if (pathParts.length > rootLength) {
                    this.props.setBackButtonFunc(this.goUp);
                  } else {
                    this.props.setBackButtonFunc(null);
                  }
                } else {
                  this.props.setShowFavButton(true);
                }

                this.props.setTitle(currentContent ? currentContent.title : null);
                _context7.next = 116;
                break;

              case 18:
                if (!sibling) {
                  _context7.next = 25;
                  break;
                }

                _currentContent = _KESI2Helper["default"].getContentByPath(nextPathArray);

                if (nextPathArray.length > 2) {
                  idOfContentWithBackside = (0, _ArrayHelper.getLastElement)(nextPathArray);
                } else {
                  pathArrayWithOutLastElement = nextPathArray.slice(0, nextPathArray.length - 1);
                  idOfContentWithBackside = (0, _ArrayHelper.getLastElement)(pathArrayWithOutLastElement);
                }

                this.setState({
                  // currentContent,
                  contentPathArray: nextPathArray,
                  idOfContentWithBackside: idOfContentWithBackside,
                  flipped: false,
                  navigationAllowed: true,
                  initialized: true,
                  doNotRenderFlipping: false
                });
                this.props.setTitle(_currentContent ? _currentContent.title : null);
                _context7.next = 116;
                break;

              case 25:
                if (!onlySameRoot) {
                  _context7.next = 40;
                  break;
                }

                _currentContent2 = _KESI2Helper["default"].getContentByPath(nextPathArray);
                _pathArrayWithOutLastElement = nextPathArray.slice(0, nextPathArray.length - 1);
                _idOfContentWithBackside = (0, _ArrayHelper.getLastElement)(nextPathArray);
                this.setState({
                  // currentContent,
                  contentPathArray: _pathArrayWithOutLastElement,
                  idOfContentWithBackside: _idOfContentWithBackside,
                  flipped: true,
                  navigationAllowed: true,
                  initialized: true,
                  animated: true,
                  doNotRenderFlipping: true
                });
                nextContent = _KESI2Helper["default"].getContentByPath(nextPathArray);
                this.props.setTitle(nextContent.title);

                if (!(nextContent.type !== 'lecture')) {
                  _context7.next = 36;
                  break;
                }

                _context7.next = 35;
                return this.waitForNextTilesComponentDidUpdate();

              case 35:
                this.setState({
                  contentPathArray: nextPathArray,
                  idOfContentWithBackside: null,
                  flipped: false
                });

              case 36:
                this.props.setTitle(_currentContent2 ? _currentContent2.title : null);
                this.props.setBackButtonFunc(this.goUp);
                _context7.next = 116;
                break;

              case 40:
                if (!goingDown) {
                  _context7.next = 77;
                  break;
                }

                _idOfContentWithBackside2 = (0, _ArrayHelper.getLastElement)(nextPathArray); // this is necessary only for desktop browsers where an appearing scroll bar changes the available space and thus
                // the layout of the elements

                this.props.setScrollBarHidden(true);
                this.setState({
                  showBackground: true,
                  idOfContentWithBackside: _idOfContentWithBackside2,
                  flipped: false,
                  navigationAllowed: false,
                  doNotRenderFlipping: false
                });

                if (hideTileTransitions) {
                  _context7.next = 49;
                  break;
                }

                _context7.next = 47;
                return this.waitForNextTilesComponentDidUpdate();

              case 47:
                _context7.next = 49;
                return (0, _TimeoutHelper.timeout)(this.getDeviceSpecificGoingDownWaitingTime());

              case 49:
                state = {
                  showBackgroundTiles: true
                };

                if (nextPathArray.length === 2) {
                  state.hideTileForIdInBackground = _idOfContentWithBackside2;
                }

                this.setState(state);

                if (hideTileTransitions) {
                  _context7.next = 55;
                  break;
                }

                _context7.next = 55;
                return this.waitForNextTilesComponentDidUpdate();

              case 55:
                this.setState({
                  flipped: true
                });

                if (hideTileTransitions) {
                  _context7.next = 61;
                  break;
                }

                _context7.next = 59;
                return this.waitForNextTilesComponentDidUpdate();

              case 59:
                _context7.next = 61;
                return (0, _TimeoutHelper.timeout)(_DrupalTiles.ANIMATION_DURATION);

              case 61:
                // // disable transitioned top value change, otherwise the opened lecture moves after the opening transition
                this.setState({
                  rootFlipped: false,
                  animated: false
                });

                if (this.isRoot()) {
                  // disable scrolling in outer document
                  // In case you observe problems in other KESIs (than deges) try to remove this line and see if it gets better
                  this.prevDocumentOverflow = document.documentElement.style.overflow;
                  document.documentElement.style.overflow = 'hidden';
                }

                _nextContent = _KESI2Helper["default"].getContentByPath(nextPathArray);

                if (!_config["default"].keepSpocTitles) {
                  this.props.setTitle(_nextContent.title);
                }

                newState = {
                  navigationAllowed: true,
                  hideTileForIdInBackground: null
                };

                if (_nextContent.type !== 'lecture') {
                  // i.e. this is the last page consisting of nuggets only
                  newState.contentPathArray = nextPathArray;
                  newState.idOfContentWithBackside = null;
                  newState.flipped = false;
                  newState.rootFlipped = false;

                  if (_nextContent.type === 'spoc') {
                    this.props.setShowFavButton(true);
                  }
                } else {
                  this.props.setShowFavButton(false);
                  newState.showGoUpButtonOnBack = true;
                }

                this.setState(newState);
                this.props.setScrollBarHidden(false);

                if (_config["default"].showBackInNavBarInsteadOfCloseButtonForNuggets) {
                  this.props.setBackButtonFunc(this.goUp);
                }

                if (hideTileTransitions) {
                  _context7.next = 73;
                  break;
                }

                _context7.next = 73;
                return this.waitForNextTilesComponentDidUpdate();

              case 73:
                // await timeout(ANIMATION_DURATION)
                this.setState({
                  animated: true
                });

                _TilesAnimationHelper["default"].fireEvent(_TilesAnimationHelper.TILES_ANIMATION_EVENT_NAMES.animationDone);

                _context7.next = 116;
                break;

              case 77:
                if (!goingUp) {
                  _context7.next = 116;
                  break;
                }

                this.props.setScrollBarHidden(true);
                _idOfContentWithBackside3 = (0, _ArrayHelper.getLastElement)(prevPathArray);
                parentCourse = _KESI2Helper["default"].getContentByPath((0, _ArrayHelper.getArrayWithoutLastElement)(prevPathArray));
                this.setState({
                  contentPathArray: nextPathArray,
                  flipped: true,
                  animated: false,
                  navigationAllowed: false,
                  showGoUpButtonOnBack: false,
                  closingTransitionForTile: parentCourse.id === _KESI2Helper["default"].getSpocTree().id ? _idOfContentWithBackside3 : null,
                  doNotRenderFlipping: false
                });

                if (hideTileTransitions) {
                  _context7.next = 87;
                  break;
                }

                _context7.next = 85;
                return this.waitForNextTilesComponentDidUpdate();

              case 85:
                _context7.next = 87;
                return (0, _TimeoutHelper.timeout)(this.getDeviceSpecificGoingUpWaitingTime());

              case 87:
                this.setState({
                  animated: true
                });

                if (hideTileTransitions) {
                  _context7.next = 93;
                  break;
                }

                _context7.next = 91;
                return this.waitForNextTilesComponentDidUpdate();

              case 91:
                _context7.next = 93;
                return (0, _TimeoutHelper.timeout)();

              case 93:
                this.setState({
                  idOfContentWithBackside: _idOfContentWithBackside3
                }); // const rootIdParts = target.rootId.split(KESI_PATH_DELIMITER)

                rootIdParts = _config["default"].cordovaStartUrl().split(_KesiConstants.KESI_PATH_DELIMITER);
                rootId = rootIdParts.length > 0 ? rootIdParts[rootIdParts.length - 1] : _KESI2Helper["default"].getSpocTree().id;
                willBeRoot = rootId === (0, _ArrayHelper.getLastElement)(this.props.contentPathArray);
                console.log('INFO', 'DrupalNestedFlippingTiles.prepareUpcomingAnimation', 'rootId', rootId, willBeRoot, (0, _ArrayHelper.getLastElement)(this.props.contentPathArray));
                this.setState({
                  flipped: false,
                  showBackgroundTiles: !willBeRoot,
                  willBeRoot: willBeRoot
                });

                if (hideTileTransitions) {
                  _context7.next = 104;
                  break;
                }

                _context7.next = 102;
                return this.waitForNextTilesComponentDidUpdate();

              case 102:
                _context7.next = 104;
                return (0, _TimeoutHelper.timeout)(_DrupalTiles.ANIMATION_DURATION);

              case 104:
                this.props.setTitle(parentCourse.title);
                nextState = {
                  idOfContentWithBackside: null,
                  navigationAllowed: true,
                  closingTransitionForTile: null
                };

                if (willBeRoot) {
                  nextState.showBackground = false;
                  this.setState(nextState);

                  if (!_config["default"].showOnlyLectures) {
                    this.props.setShowFavButton(null);
                  } else {
                    this.props.setShowFavButton(true);
                  }

                  this.props.setBackButtonFunc(null);
                } else {
                  this.setState(nextState);
                  this.props.setShowFavButton(true);

                  if (_config["default"].showOnlyLectures) {
                    this.props.setBackButtonFunc(null);
                  }
                }

                this.props.setScrollBarHidden(false);

                if (willBeRoot) {
                  document.documentElement.style.overflow = this.prevDocumentOverflow;
                }

                if (hideTileTransitions) {
                  _context7.next = 114;
                  break;
                }

                _context7.next = 112;
                return this.waitForNextTilesComponentDidUpdate();

              case 112:
                _context7.next = 114;
                return (0, _TimeoutHelper.timeout)(0);

              case 114:
                if (willBeRoot) {
                  this.setState({
                    willBeRoot: false
                  });
                }

                _TilesAnimationHelper["default"].fireEvent(_TilesAnimationHelper.TILES_ANIMATION_EVENT_NAMES.animationDone);

              case 116:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function prepareUpcomingAnimation(_x6, _x7) {
        return _prepareUpcomingAnimation.apply(this, arguments);
      }

      return prepareUpcomingAnimation;
    }()
  }, {
    key: "waitForNextTilesComponentDidUpdate",
    value: function () {
      var _waitForNextTilesComponentDidUpdate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.onTilesComponentDidUpdate = function () {
                  return _promise["default"].resolve();
                };

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function waitForNextTilesComponentDidUpdate() {
        return _waitForNextTilesComponentDidUpdate.apply(this, arguments);
      }

      return waitForNextTilesComponentDidUpdate;
    }()
  }, {
    key: "renderExtraButtons",
    value: function renderExtraButtons() {
      return null; // return (
      //   <div>
      //     <div className={s.tilesButtonsExtra}>
      //       <span onTouchTap={this.reverseOrder} style={{padding: 10, width: 140, backgroundColor:
      // 'lightgreen'}}>Reihenfolge umkehren</span> </div> </div> );
    }
  }, {
    key: "getFrameElementId",
    value: function getFrameElementId(forBackground) {
      var background = forBackground ? 'background' : 'not-background';
      return "tiles-frame-".concat(background, "-").concat((0, _ArrayHelper.getLastElement)(this.state.contentPathArray));
    }
  }, {
    key: "isRoot",
    value: function isRoot() {
      /* console.log('INFO', 'DrupalNestedFlippingTiles.isRoot',
        'contentPathArray', JSON.stringify(this.state.contentPathArray), getLastElement(this.state.contentPathArray),
        'Kesi2Helper.getSpocTree()', JSON.stringify(Kesi2Helper.getSpocTree()), Kesi2Helper.getSpocTree().id) */
      return (0, _ArrayHelper.getLastElement)(this.state.contentPathArray) === _KESI2Helper["default"].getSpocTree().id;
    }
  }, {
    key: "getLogoStyle",
    value: function getLogoStyle() {
      return {
        width: '160px',
        position: 'absolute',
        bottom: '30px',
        left: '50%',
        transform: 'translateX(-50%)'
      };
    }
  }, {
    key: "renderLogo",
    value: function renderLogo() {
      if (_config["default"].bottomLogo) {
        return /*#__PURE__*/_react["default"].createElement("img", {
          src: _config["default"].bottomLogo,
          style: this.getLogoStyle()
        });
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.initialized) {
        return /*#__PURE__*/_react["default"].createElement("div", null);
      }

      var style = this.getStyle();
      var isRoot = this.isRoot();
      var showBackgroundTiles = this.state.showBackgroundTiles; // this.state.contentPathArray.length > 1 && ((isRoot && this.state.flipped) || (!isRoot))

      var backgroundScrollId = this.getScrollElementId(true);
      var foregroundScrollId = this.getScrollElementId(false);
      var foregroundScrollStyle;
      var backgroundScrollStyle; // if (isRoot && !this.state.flipped) {

      if (isRoot && !this.state.rootFlipped) {
        foregroundScrollStyle = style.tileFrameRoot;
      } else if (!isRoot && this.state.flipped) {
        // else if (!isRoot && this.state.flipped) {
        foregroundScrollStyle = style.tileFrameRootFlipped;
      } else {
        foregroundScrollStyle = style.tileFrame;
      }

      var isZoomed = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.IS_ZOOMED);

      if (isZoomed) {
        if (!isRoot && this.state.flipped) {
          foregroundScrollStyle.overflow = 'scroll hidden';
        } else {
          foregroundScrollStyle.overflow = 'scroll';
        }
      }

      if (!this.state.showBackground) {
        backgroundScrollStyle = style.backgroundTilesHidden;
      } else {
        backgroundScrollStyle = style.backgroundTiles;
      }

      var logo = this.renderLogo();
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _NestedFlipTiles["default"].tileFrame,
        id: this.outerPageId
      }, this.renderExtraButtons(), _config["default"].showOnlyLectures || _config["default"].hideFlippedTileBackground ? null : /*#__PURE__*/_react["default"].createElement("div", {
        id: backgroundScrollId,
        className: "scrollFrame",
        style: backgroundScrollStyle
      }, /*#__PURE__*/_react["default"].createElement(_FlippingTiles["default"], {
        setCount: function setCount() {},
        contentPathArray: _config["default"].usesCourses ? [_KESI2Helper["default"].getCourseTree().id] : [_KESI2Helper["default"].getSpocTree().id],
        flipped: false,
        animated: false,
        zoomValue: this.state.zoomValue,
        colCount: this.state.colCount,
        goUpFunc: function goUpFunc() {},
        showGoUpButton: false,
        showGoUpButtonOnBack: false,
        navigationAllowed: false,
        isInBackground: true,
        isRoot: true,
        hideTileForId: this.state.hideTileForIdInBackground || this.state.contentPathArray[1] || this.state.lastPath[1],
        isHidden: !showBackgroundTiles,
        scrollFrameId: backgroundScrollId,
        rootScrollTop: this.state.scrollTop,
        setShowFavButton: this.props.setShowFavButton,
        setBackButtonFunc: this.props.setBackButtonFunc,
        forcedHeight: (isRoot || this.state.willBeRoot) && showBackgroundTiles ? '100%' : null
      }), logo), /*#__PURE__*/_react["default"].createElement("div", {
        id: foregroundScrollId,
        className: "scrollFrame",
        style: foregroundScrollStyle
      }, /*#__PURE__*/_react["default"].createElement(_FlippingTiles["default"], {
        setCount: this.props.setCount,
        contentPathArray: this.state.contentPathArray,
        flipped: this.state.flipped,
        renderChildrenForId: this.state.idOfContentWithBackside,
        onComponentDidUpdate: this.onTilesComponentDidUpdateCallback,
        animated: this.state.animated,
        zoomValue: this.state.zoomValue,
        colCount: this.state.colCount,
        goUpFunc: this.goUp,
        showGoUpButton: !_config["default"].showBackInNavBarInsteadOfCloseButtonForNuggets && this.state.navigationAllowed && this.state.contentPathArray.length >= 2,
        showGoUpButtonOnBack: !_config["default"].showBackInNavBarInsteadOfCloseButtonForNuggets && this.state.showGoUpButtonOnBack,
        navigationAllowed: this.state.navigationAllowed,
        isRoot: isRoot,
        renderFront: _config["default"].scaleOverlayTiles >= 1 || !isRoot || !this.state.flipped,
        scrollFrameId: foregroundScrollId,
        onOpenTile: this.onOpenTile,
        showOnlyTileWithId: _config["default"].scaleOverlayTiles >= 1 ? null : this.state.closingTransitionForTile,
        hideTileForId: _config["default"].scaleOverlayTiles >= 1 ? null : this.state.closingTransitionForTile,
        rootScrollTop: this.state.scrollTop,
        showBackground: _config["default"].scaleOverlayTiles >= 1 || this.state.showBackground,
        setShowFavButton: this.props.setShowFavButton,
        doNotRenderFlipping: this.state.doNotRenderFlipping,
        setBackButtonFunc: this.props.setBackButtonFunc,
        coloredBackground: showBackgroundTiles
      }), !this.state.showBackground ? logo : null));
    }
  }]);
  return DrupalNestedFlippingTiles;
}(_KESI2BasicComponent["default"]);

DrupalNestedFlippingTiles.propTypes = {
  setTitle: _propTypes["default"].func,
  setCount: _propTypes["default"].func,
  setScrollBarHidden: _propTypes["default"].func.isRequired,
  setBackButtonFunc: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  setShowFavButton: _propTypes["default"].func.isRequired
};
DrupalNestedFlippingTiles.defaultProps = {
  setTitle: function setTitle() {}
};
var _default = DrupalNestedFlippingTiles;
exports["default"] = _default;